// extracted by mini-css-extract-plugin
export default {"fs":"_18b161d85f _91263f9b9a"};